import { render, staticRenderFns } from "./classify-carousel.vue?vue&type=template&id=52b984e8&scoped=true&"
import script from "./classify-carousel.vue?vue&type=script&lang=ts&"
export * from "./classify-carousel.vue?vue&type=script&lang=ts&"
import style0 from "./classify-carousel.vue?vue&type=style&index=0&id=52b984e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b984e8",
  null
  
)

export default component.exports